<template>
	<page>
		<module :title="id ? '编辑优惠券' : '新建优惠券'">
			<c-form ref="form">
				<c-form title="基础信息">
					<c-form-item type="input" label="优惠券名称" name="coupon_name"  maxlength="20" required></c-form-item>
					<c-form-item v-model="salesType" type="radio" label="优惠方式" name="coupon_kinds" :options="salesTypeOption" required></c-form-item>
					<c-form-item>
						<div class="limit flex">
							<div v-show="salesType != 1" class="flex-center-cross item">
								<label>{{salesType == 2 ? '满' : '每满'}}</label>
								<c-input v-model="limit" type="number" decimal="2" width="135" height="38" word="元"></c-input>
							</div>
							<div class="flex-center-cross item">
								<label>减</label>
								<c-input v-model="sales" type="number" decimal="2" width="135" height="38" word="元"></c-input>
							</div>
						</div>
					</c-form-item>
					<c-form-item type="textarea" label="使用说明" name="coupon_description"></c-form-item>
				</c-form>
				
				<c-form title="适用范围">
					<c-form-item type="input" label="使用条件简述" name="commodity_remark" required maxlength="8"></c-form-item>
					<c-form-item v-model="commodityRange" type="radio" label="可用范围" name="commodity_range" :options="commodityRangeOption" required></c-form-item>
					<c-form-item v-show="commodityRange == 2">
						<m-operate>
							<c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
						</m-operate>
						
						<c-table ref="productList" v-model="productList" height="500" :paging="false" border>
							<c-table-column
								label="状态"
								name="state"
								width="100"
							>
								<template v-slot="{data}">
									{{dict.productState[data.state]}}
								</template>
							</c-table-column>
							
							<c-table-column
								label="商品信息"
								name="product_name"
								width="250"
							>
								<template v-slot="{data}">
									<div class="flex-center">
										<c-image :src="data.product_img_url" size="46" preview></c-image>
										<p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                            <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                            {{data.product_name}}
                                        </p>
									</div>
								</template>
							</c-table-column>

							<c-table-column
								label="上架时间"
								name="sell_state_date"
								width="150"
							></c-table-column>
							
							<c-table-column
								type="button"
								fixed="right"
								label="操作"
								width="100"
							>
								<template v-slot="row">
									<c-table-button @click="row.remove()">删除</c-table-button>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
					<c-form-item v-show="commodityRange == 3">
						<div>
							<c-form ref="attrForm" item-width="400" inline>
								<c-form-item v-model="classify" type="select" label="商品类目" name="product_type_id" options="PRODUCT_CLASSIFY" multiple></c-form-item>
								<c-form-item v-model="brand" type="select" label="品牌" name="brand_id" value="71,62" options="BRAND" multiple></c-form-item>
							</c-form>
						</div>
					</c-form-item>
				</c-form>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit(1)">确定提交</c-button>
				<c-button size="m" hollow @click="submit(0)">暂存草稿</c-button>
			</template>
		</module>
		
		<product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
	</page>
</template>

<script>
	import productSelector from '@/components/service/product_selector.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'coupon_edit',
		
		components: {
			productSelector
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				salesType: 1,
				salesTypeOption: [{
					name: '无门槛券',
					value: 1
				}, {
					name: '满减券',
					value: 2
				}, {
					name: '满减叠加券',
					value: 3
				}],
				
				limit: '',
				sales: '',
				
				commodityRange: 1,
				commodityRangeOption: [{
					name: '全部商品',
					value: 1
				}, {
					name: '指定商品',
					value: 2
				}, {
					name: '指定条件',
					value: 3
				}],
				
				productList: [],
				
				classify: '',
				brand: ''
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getCoupontDetail();
			},
			
			commodityRange(val) {
				if (val == 2) {
					this.$refs.productList.resize();
				}
			}
		},
		
		mounted() {
			this.id && this.getCoupontDetail();
		},
		
		methods: {
			getCoupontDetail() {
				this.request({
					url: '/couponInfo/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set(data);
						data.coupon_kinds != 1 && (this.limit = data.condition_amount);
						this.sales = data.decrease_amount;
						
						if (data.commodity_range == 2) {
							this.productList = data.product_list || [];
						}
						
						if (data.commodity_range == 3 && data.commodity_condition_json) {
							let range = JSON.parse(data.commodity_condition_json);
							this.classify = range.classify_ids;
							this.brand = range.brand_ids;
						}
					}
				});
			},
			
			productSelectHandle(list) {
				list = list.filter(item => {
					return !this.productList.find(row => {
						return row.product_id == item.product_id;
					});
				});
				this.productList = this.productList.concat(list);
			},
			
			submit(state) {
				this.$refs.form.submit({
					url: this.id ? '/couponInfo/edit' : '/couponInfo/add',
					
					rule: {
						coupon_name: '请填写优惠券名称',
						coupon_sales: [{
							type: 'function',
							fun: () => {
								return this.sales && (this.salesType == 1 || this.limit);
							},
							word: this.salesType == 1 ? '请填写优惠券金额' : '请填写优惠券门槛和金额'
						}],
						commodity_remark: '请填写使用条件简述',
						coupon_range: [{
							type: 'function',
							fun: () => {
								return this.commodityRange == 1 || (this.commodityRange == 2 && this.productList.length) || (this.commodityRange == 3 && (this.classify || this.brand));
							},
							word: this.commodityRange == 2 ? '请选择指定商品' : '请选择指定条件'
						}]
					},
					
					dataFormatter: data => {
						this.id && (data.id = this.id);
						data.state = state;
						data.condition_amount = this.limit || 0;
						data.decrease_amount = this.sales;
						
						if (data.commodity_range == 2) {
							data.product_list = Array.from(this.productList, item => {
								return {
									product_id: item.product_id
								}
							});
						} else if (data.commodity_range == 3) {
							data.commodity_condition_json = JSON.stringify({
								brand_ids: this.brand,
								classify_ids: this.classify
							});
						}
						
						return data;
					},
					
					success: () => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('couponList.update');
						this.redirectTo('/coupon_list');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.limit {
		.item {
			margin-right: 16px;
			
			label {
				margin-right: 8px;
			}
		}
	}
</style>